import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import './formElements.scss';
import downArraow from './../../assets/images/icons/down-arrow.svg'
import upArraow from './../../assets/images/icons/up-arrow.svg'
import epl from './../../assets/images/leagues/epl.png'

class CustomDropDown extends Component {
    constructor(props) {
        super(props);
        this.state = {
            listOpen: false,
            selectedItem: this.props.selectedItem,
            searchQuery: ''
        }
        this.dropdownId = "custom-drodown-container";
    }
    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside)
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside)
    }

    handleClickOutside = event => {
        let dialogClick = false;
        //for mozilla
        //https://stackoverflow.com/questions/39245488/event-path-undefined-with-firefox-and-vue-js
        let path = event.path || (event.composedPath && event.composedPath());
        path.every(element => {
            if (element.id === this.dropdownId) {
                dialogClick = true;
                return false;
            }
            return true;
        })

        if (!dialogClick) { // it clicked on outside the dialog
            this.setState({
                listOpen: false,
                searchQuery: ''
            },()=>{
                this.props.toggleDropDown(this.state.listOpen)
            })
        }
    }
    toggleList = () => {
        this.setState({
            listOpen: !this.state.listOpen,
            searchQuery: this.state.listOpen ? '' : this.state.searchQuery
        },()=>{
            this.props.toggleDropDown(this.state.listOpen)
        })
    }

    selectItem = (data) => {
        this.props.selectItem(data)
        this.setState({
            selectedItem: { id: data.id, value: data.value, img: data.img },
            listOpen: false,
            searchQuery: ''
        },()=>{
            this.props.toggleDropDown(this.state.listOpen)
        })
    }

    onSearchChange = (e) => {
        this.setState({ searchQuery: e.target.value || '' })
    }

    render() {
        const { customStyle, options, placeholder, noBorder, showSearch } = this.props;
        const { listOpen, selectedItem, searchQuery } = this.state;
        const query = (searchQuery || '').trim().toLowerCase();
        const filteredOptions = showSearch && query
            ? (options || []).filter((row) => (row.value || '').toLowerCase().includes(query))
            : (options || []);
        return (
            <div className={`custom-dropdown-wrapper ${customStyle}`} id={this.dropdownId}>
                <div className={`${noBorder ? "noBorder" : "border"} dd-header`} onClick={this.toggleList}>
                    <div className="dd-header-title">
                        {selectedItem && selectedItem.value ?
                            <div className="selected-item">
                                <img src={selectedItem.id===524 ? epl: selectedItem.img} className="dd-list-item-img" />
                                <span className={noBorder ? "only-for-pc" :''}>{selectedItem.value.substring(0, selectedItem.value.lastIndexOf('-'))}</span>
                            </div>
                            : placeholder}
                        {listOpen ?
                            <img src={upArraow} className="dd-down-arrow-icon" alt="down-arrow" /> :
                            <img src={downArraow} className="dd-down-arrow-icon" alt="down-arrow" />}
                    </div>
                </div>
                {listOpen ?
                    <div className="dd-list">
                        {showSearch ? (
                            <div className="dd-list-search" onClick={(e) => e.stopPropagation()}>
                                <input
                                    type="text"
                                    className="dd-list-search-input"
                                    placeholder="Search leagues..."
                                    value={searchQuery}
                                    onChange={this.onSearchChange}
                                    onKeyDown={(e) => e.stopPropagation()}
                                    autoFocus
                                />
                            </div>
                        ) : null}
                        <div className="dd-list-items-wrap">
                            {filteredOptions.length > 0 ?
                                filteredOptions.map((rowData, index) => {
                                    return (
                                        <div key={`${rowData.id}-${index}`} onClick={() => this.selectItem(rowData)} className="dd-list-item"><img src={rowData.id===524 ? epl: rowData.img} className="dd-list-item-img" /> {rowData.value}</div>
                                    )
                                }) : (
                                    showSearch && query ? <div className="dd-list-item dd-list-no-results">No leagues match</div> : null
                                )
                            }
                        </div>
                    </div>
                    : null}
            </div>
        )
    }
}

CustomDropDown.defaultProps = {
    selectedItem: null,
    customStyle: "",
    noBorder: false,
    showSearch: false,
    toggleDropDown:()=>{}
}

CustomDropDown.propTypes = {
    options: PropTypes.array,
    selectedItem: PropTypes.object,
    noBorder: PropTypes.bool,
    showSearch: PropTypes.bool,
    toggleDropDown:PropTypes.func
}

export default CustomDropDown;